import React from 'react';
import PhoenixDocCard from 'components/base/PhoenixDocCard';
import ConnectionFileStore from 'shiplab-components/ConnectionFileStore';
import { Spinner } from 'react-bootstrap';
import { useDataAccessContext } from './useDataAccessContext';

const DataAccessDataLakePage: React.FC = () => {
  const { profile, fileStoreConnections, loading } = useDataAccessContext();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading…</span>
        </Spinner>
      </div>
    );
  }

  return (
    <PhoenixDocCard className="mb-4">
      <PhoenixDocCard.Body>
        <ConnectionFileStore
          connections={fileStoreConnections}
          invoiceFormat={profile?.invoice_format}
        />
      </PhoenixDocCard.Body>
    </PhoenixDocCard>
  );
};

export default DataAccessDataLakePage;
